
import { loadStripe, Stripe } from '@stripe/stripe-js';
import {Config} from "./APIAndConfig";
export async function getStripe(): Promise<Stripe | null> {
    if (Config.StripePublicKey)
        return await loadStripe(Config.StripePublicKey)
    return null;
}
